/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Profile fields that can be updated by end-user
 */
import { ValidateUtils } from 'app/shared/utils';

export class UserProfileUpdate { 
    firstName: string;
    lastName: string;

    constructor(item?: Partial<UserProfileUpdate>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            firstName: {
                
                minLength: 1,
                maxLength: 100,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.firstName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 1, 100);
                    }

                    return result;
                }
            },
            lastName: {
                
                minLength: 1,
                maxLength: 100,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.lastName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 1, 100);
                    }

                    return result;
                }
            },
            isValid: UserProfileUpdate.isValid,
        };
    }

    static isValid(obj: UserProfileUpdate): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = UserProfileUpdate.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.firstName.isValid(item);
            result = result && validationObject.lastName.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

